<template>
  <div class="tgh-residential-details">
    <router-link to="/gallery-catalogue" class="tgh-close-rd">
      <img src="../assets/images/close.png" alt="">
    </router-link>
    <hooper>
      <slide v-for="(gallery,galleryIndex) in gallery.images" :key="`gallery-im-${galleryIndex}`">
        <div class="tgh-rd-images">
          <img :src="gallery.photo" alt="">
          <span class="tgh-rd-dots" :style="`left:${galink.position.split(',')[0]}%;top:${galink.position.split(',')[1]}%`" @click="details(galinkIndex,galleryIndex)" v-for="(galink,galinkIndex) in gallery.links" :key="`galink-${galinkIndex}`"></span>
          <transition name="custom-classes-transition"
            enter-active-class="animated zoomIn"
            leave-active-class="animated zoomOut">
          <div class="tgh-rd-popup" v-show="showDetails">
              <img src="../assets/images/close-grey.png" alt="" class="tgh-rdp-close" @click="closeDetails()">
              <div class="row">
                  <div class="col-11 col-md-7">
                      <h1>{{ link.title }}</h1>
                  </div>
              </div>
              <div class="row">
                  <div class="col-7">
                      <img :src="link.photo" alt="">
                  </div>
                  <div class="col-5">
                      <h5>SPECIFICATION</h5>
                      <div v-html="link.description"></div>
                  </div>
              </div>
              <div class="tgh-rdp-order">
                  <h4>FOR ORDER :</h4>
                  <h6>CONTACT US OR VISIT OUR SPACE</h6>
                  <a href="mailto:info@tengahtengah.com">info@tengahtengah.com</a>
              </div>
          </div>
          </transition>
        </div>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
} from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: 'CollaboratorsDetails',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data() {
      return {
          showDetails : false,
          gallery : [],
          link : {
            title : '',
            photo : false,
            description : ''
          }
      }
  },
  methods : {
      details(index,galIndex) {
          this.showDetails = true
          this.link = this.gallery.images[galIndex].links[index]
      },
      closeDetails() {
          this.showDetails = false
      },
      getData(){
        let vm = this
        let url = apiUrl+'/gallery/get'
        let data = {
          id : this.$route.params.id
        }
        axios.post(
            url,
            data
        )
        .then(response => {
            if(response.data.status){
                vm.gallery = response.data.data
            }
        })
        .catch(e => {
            console.log('Internal server error')
        })
      }
  },
  mounted() {
    this.getData()
    this.$store.commit('goFullScreen')
  },
  destroyed() {
    this.$store.commit('exitFullScreen')
  }
}
</script>
